import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ErrorHandler,
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { ErrorTracking } from './error-tracking.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {
  isBrowser: boolean;

  constructor(
    private errorTracking: ErrorTracking,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response,
  ) {
    super();
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  handleError(value: any): void {
    // Backport of https://github.com/angular/angular/pull/31443 to unwrap
    // unhandled Promises
    // FIXME: remove when https://github.com/angular/angular/pull/31443 has
    // landed & we've upgraded.
    let error: any;
    if (
      value.rejection &&
      (value.rejection instanceof Error || value.rejection.message)
    ) {
      error = value.rejection;
    } else {
      error = value;
    }

    // When on the server, abort & return a 500
    if (isPlatformServer(this.platformId)) {
      // The Angular Router currently throws on URLs with scripts tags or
      // invalid characters
      // See https://github.com/angular/angular/issues/21032
      if (
        error.message.includes('Error: Cannot match any routes. URL Segment: ')
      ) {
        this.response.status(400);
        this.response.locals.error = error;
        return;
      }
      this.response.status(500);
      this.response.locals.error = error;
      return;
    }
    // When on the browser, report to Sentry
    // We don't log backend errors in Sentry as there are already logged in
    // Kibana
    if (!(error instanceof HttpErrorResponse)) {
      if (error instanceof Error) {
        this.errorTracking.captureException(error);
      } else {
        this.errorTracking.captureMessage(error.message || error);
      }
    }
    // Angular's native error handler breaks WebDriverJS console read API.
    // FIXME: detect Protractor env better
    if (
      isPlatformBrowser(this.platformId) &&
      window.location.host === 'localhost:5000'
    ) {
      console.error(error);
    } else {
      super.handleError(error);
    }
  }
}
